<template>
  <div class="alert-danger">
    <div class="row justify-content-center">
      <div class="col-6 text-center m-3 p-0">
        <h2 class="h4">
          {{ error }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  data() {
    return {

    };
  },
  props: {
    error: {
      type: String,
      required: true,
    }
  },
});
</script>
